import React from "react";
import "../component/doctorTreatmentTable.css";
import { formatRupiah } from "../../../helper/formatNumber";

const DoctorTreatmentTable = ({
  page,
  treatments,
  onEditTreatmentClicked,
  onDeleteTreatmentClicked,
}) => {
  const editTreatment = (treatment) => {
    onEditTreatmentClicked(treatment);
  };

  const deleteTreatment = (treatment) => {
    onDeleteTreatmentClicked(treatment);
  };

  return (
    <div className="doctor-treatment-table-container">
      <table className="doctor-treatment-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Tindakan Medis</th>
            <th>Harga</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {treatments.length > 0 ? (
            treatments.map((treatment, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{treatment.doctor_treatment_name}</td>
                <td>{formatRupiah(treatment.doctor_treatment_price)}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editTreatment(treatment);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteTreatment(treatment);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DoctorTreatmentTable;
